module.exports = __webpack_public_path__ + "img/bosspack_dfod.df02d7f0.png";